
import { registerComponents } from './register-components'

const init = async () => {
  registerComponents()
}


init()